import React, { useEffect, useRef, useState } from 'react'
import style from './index.module.scss'
import {
    CommonObj,
} from '../utils';
import { group_C, group_D } from './constans';
import Card1 from '../components/Card_1';
import { post } from 'common/utils';

const Comp = (props) => {
    const { refreshTick } = props;
    const currScene = useRef(props.sceneInfo);
    const onLoadOver = useRef(props.onLoadOver);
    const [gpCIndex, setgpCIndex] = useState(null);
    const [gpDIndex, setgpDIndex] = useState(null);
    const [tag2Value, setTag2Value] = useState({});

    const queryLock = useRef(null);
    useEffect(() => {
        if (typeof refreshTick === 'symbol') {
            // refresh signal
            const tag_name_list = []
                .concat(
                    ...(
                        group_C.children.map((child) => {
                            const { basic_tag, tag_1, tag_2, tag_3, tag_4, tag_5, tag_6 } = child;
                            return [tag_1, tag_2, tag_3, tag_4, tag_5, tag_6].map((tag) => basic_tag + tag);
                        })
                    ),
                    ...(
                        group_D.children.map((child) => {
                            const { basic_tag, tag_1, tag_2, tag_3, tag_4, tag_5, tag_6 } = child;
                            return [tag_1, tag_2, tag_3, tag_4, tag_5, tag_6].map((tag) => basic_tag + tag);
                        })
                    ),
                );
            const trimed_tag_name_list = [...new Set(tag_name_list)];
            const currLock = Symbol();
            queryLock.current = currLock;
            post(process.env.REACT_APP_SERVER_PATH + 'api/data/get_values_before_time_x', {
                tag_name_list: trimed_tag_name_list,
            })
                .then((retData) => {
                    if (queryLock.current !== currLock) {
                        return;
                    };
                    // console.log(retData);
                    if (retData.data && retData.data.errcode === 0) {
                        setTag2Value(retData.data.results);
                    };
                });
        };
        return () => {
            queryLock.current = Symbol();
        };
    }, [refreshTick]);

    useEffect(() => {
        onLoadOver.current = props.onLoadOver;
    }, [props]);
    useEffect(() => {
        if (!currScene.current) return;
        currScene.current.displayFunc(
            {//Action-2
                num: group_C.children.length,
                cb: (index) => {
                    // console.log(`now C display no.${index}`);
                    setgpCIndex(index);
                },
            },
            {//Action-3
                num: group_D.children.length,
                cb: (index) => {
                    // console.log(`now D display no.${index}`);
                    setgpDIndex(index);
                },
            },
            {//Action-4
                cb: () => {
                    // console.log("C,D消失");
                    setgpCIndex(null);
                    setgpDIndex(null);
                },
            },
            {//over
                cb: () => {
                    // console.log("over");
                    if (typeof onLoadOver.current === 'function') {
                        onLoadOver.current();
                    };
                },
            },
        );
        return () => {
            clearTimeout(CommonObj.mySetTimeout);
        };
    }, []);
    return (
        <div className={style['wrapper']}>
            {
                typeof gpCIndex === 'number' && (
                    <div className="gp_wrapper gpC">
                        <div className="title">{group_C.name}</div>
                        <div className="content">
                            {
                                group_C.children
                                    .map((item, index) => {
                                        const { basic_tag, tag_1, tag_2, tag_3, tag_4, tag_5, tag_6, precision_1, precision_2, precision_3 } = item;
                                        const values = [tag_1, tag_2, tag_3, tag_4, tag_5, tag_6].map((tag) => tag2Value[basic_tag + tag]);
                                        const precisions = [precision_1, precision_2, precision_3, null, null, null].map((v) => typeof v === 'number' ? v : null);
                                        return (
                                            <div style={{ marginLeft: index > 0 ? 8 : 0 }} key={index} className={index > gpCIndex ? "card_hide" : ""}>
                                                <Card1 name={item.name} unit={item.unit} standard={item.standard} values={values} precisions={precisions} />
                                            </div>
                                        );
                                    })
                            }
                        </div>
                    </div>
                )
            }
            {
                typeof gpDIndex === 'number' && (
                    <div className="gp_wrapper gpD">
                        <div className="title">{group_D.name}</div>
                        <div className="content">
                            {
                                group_D.children
                                    .map((item, index) => {
                                        const { basic_tag, tag_1, tag_2, tag_3, tag_4, tag_5, tag_6, precision_1, precision_2, precision_3 } = item;
                                        const values = [tag_1, tag_2, tag_3, tag_4, tag_5, tag_6].map((tag) => tag2Value[basic_tag + tag]);
                                        const precisions = [precision_1, precision_2, precision_3, null, null, null].map((v) => typeof v === 'number' ? v : null);
                                        return (
                                            <div style={{ marginLeft: index > 0 ? 8 : 0 }} key={index} className={index > gpDIndex ? "card_hide" : ""}>
                                                <Card1 name={item.name} unit={item.unit} standard={item.standard} values={values} precisions={precisions} />
                                            </div>
                                        );
                                    })
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Comp
